import React from 'react';
export const HowItWorks = () => {
  const steps = [{
    number: '01',
    title: 'Apply Online',
    description: 'Fill out our simple application form with details about your business and financing needs.'
  }, {
    number: '02',
    title: 'Document Submission',
    description: 'Upload the required documents to help us evaluate your business and loan eligibility.'
  }, {
    number: '03',
    title: 'Application Review',
    description: 'Our team reviews your application and documents within 48 hours.'
  }, {
    number: '04',
    title: 'Approval & Disbursement',
    description: 'Once approved, sign the loan agreement and receive funds directly to your business account.'
  }];
  return <section id="how-it-works" className="py-16 bg-white" data-id="element-949">
      <div className="container" data-id="element-950">
        <h2 className="section-title text-center" data-id="element-951">How It Works</h2>
        <p className="section-subtitle text-center" data-id="element-952">
          Our streamlined application process makes it easy to get the financing
          your business needs.
        </p>
        <div className="mt-16" data-id="element-953">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8" data-id="element-954">
            {steps.map((step, index) => <div key={index} className="relative" data-id="element-955">
                <div className="bg-emerald-50 rounded-full w-16 h-16 flex items-center justify-center mb-6" data-id="element-956">
                  <span className="text-2xl font-bold text-emerald-600" data-id="element-957">
                    {step.number}
                  </span>
                </div>
                {index < steps.length - 1 && <div className="hidden lg:block absolute top-8 left-16 w-full h-0.5 bg-emerald-100" data-id="element-958"></div>}
                <h3 className="text-xl font-semibold mb-3 text-gray-800" data-id="element-959">
                  {step.title}
                </h3>
                <p className="text-gray-600" data-id="element-960">{step.description}</p>
              </div>)}
          </div>
        </div>
        <div className="mt-16 text-center" data-id="element-961">
          <a href="#apply-now" className="btn-primary inline-block" data-id="element-962">
            Start Your Application
          </a>
        </div>
      </div>
    </section>;
};